import React, { Component, Fragment } from "react";
import $ from "jquery";
import moment from "moment";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminPageComponent } from "../common/selltowebpage/SellToWebAdminPageComponent";
import { SellToWebTableColumnComponent } from "../common/selltowebtable/SellToWebTableColumnComponent";
import { SellToWebTableRowComponent } from "../common/selltowebtable/SellToWebTableRowComponent";
import { SellToWebTableComponent } from "../common/selltowebtable/SellToWebTableComponent";

import { TenantOffersQueryComponent } from "./TenantOffersQueryComponent";
import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";
import { TenantOffersRawViewComponent } from "./TenantOffersRawViewComponent";
import { TenantOffersCRMDeliveryRawViewComponent } from "./TenantOffersCRMDeliveryRawViewComponent";
export class TenantOffersRouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingData: false,
            tenants: null,
            siteDomain: "",
            tableTitle: "",
            tableData: [],
            paintTable: false,
            showRawViewPopup: false,
            showCRMRawViewPopup: false,
            rawViewTitle: "",
            rawViewCRMTitle: "",
            rawViewData: "",
            rawViewCRMData: "",
            crmContent: "",
            crmXmlContent: "",
            crmContentConfirmed: "",
            crmXmlContentConfirmed: "",
            selectedValuationMethod: "",
            offerNumber: ""
        };

        this.onGetReportClick = this.onGetReportClick.bind(this);
        this.onViewOfferDetailCallback = this.onViewOfferDetailCallback.bind(this);
        this.onToggleViewDetails = this.onToggleViewDetails.bind(this);
        this.onRawViewClick = this.onRawViewClick.bind(this);
        this.onCRMDeliveryClick = this.onCRMDeliveryClick.bind(this);
        this.onConfirmedCRMDeliveryClick = this.onConfirmedCRMDeliveryClick.bind(this);
        this.onCancelRawView = this.onCancelRawView.bind(this);
        this.onCancelCRMRawView = this.onCancelCRMRawView.bind(this);
        this.onCopyTableCallBack = this.onCopyTableCallBack.bind(this);
        this.onCopyRawView = this.onCopyRawView.bind(this);
        this.onCopyCRMRawView = this.onCopyCRMRawView.bind(this);
        this.onCopyColumnClick = this.onCopyColumnClick.bind(this);
        this.onOfferNumberColumnCallback = this.onOfferNumberColumnCallback.bind(this);
        this.onVinColumnCallback = this.onVinColumnCallback.bind(this);
        this.onCustomerEmailColumnCallback = this.onCustomerEmailColumnCallback.bind(this);

        props.onPageChanged({
            pageTitle: this.pageTitle
        });
    }

    pageTitle = "Offers";

    componentDidMount() {
        try {
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/Tenant/Offers", pageType: "Consumer/Admin", isLoggedIn: "Yes", properties: { logon: this.props.logon } });
            CommonService.clientAzureStorageLog("TenantOffersRouteComponent", "componentDidMount", null, null, null, null, this.props.applicationInsights);
            this.getTenants();
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "componentDidMount");
        }
    }

    getTenants() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "TenantOffersRouteComponent/getTenants", properties: { logon: this.props.logon } });
            fetch("/TenantOffers/GetTenants", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        isLoadingData: false,
                        tenants: parsedResponse
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantOffers/GetTenants", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantOffersRouteComponent", "getTenants");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantOffersRouteComponent", "getTenants");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "getTenants");
        }
    }

    onGetReportClick(selectedTenant, selectedSite, startOfferDate, endOfferDate, vin, email, selectedValuationMethod, showExpired) {
        try {
            this.setState({ isLoadingData: true, siteDomain: selectedSite.siteDomain });
            let inputData = {
                siteGuid: selectedSite.guid,
                startOfferDate: startOfferDate ? CommonService.formatServerDateTime(startOfferDate.toString()) : null,
                endOfferDate: endOfferDate ? CommonService.formatServerDateTime(endOfferDate.toString()) : null,
                vin: vin,
                email: email,
                valuationMethod: null
            };
            this.props.applicationInsights.trackTrace({ message: "TenantOffersRouteComponent/onGetReportClick", properties: { ...inputData, logon: this.props.logon } });
            fetch("/TenantOffers/GetOffers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    let tableData = parsedResponse.table;

                    let currentDate = moment();
                    tableData.forEach((responseItem, index) => {
                        responseItem.vehicleVIN = responseItem.vehicle + " (" + responseItem.vin + ")";
                        responseItem.customerEmail = responseItem.customerName + " (" + responseItem.email + ")";
                        if (responseItem.source === "DGDGDash") {
                            responseItem.source_cellClassName = "admin-offers-source";
                        }
                        if (responseItem.status === "Confirmed") {
                            responseItem.rowClassName = "admin-offers-confirm";
                        }
                        else if (responseItem.status === "Warn") {
                            responseItem.rowClassName = "admin-offers-warn";
                        }
                        else if (responseItem.status === "Error") {
                            responseItem.rowClassName = "admin-offers-error";
                        }

                        let expirationDate = moment(responseItem.expirationDate);
                        if (currentDate > expirationDate) {
                            responseItem.rowClassName = "admin-offers-expired";
                            responseItem.isExpired = true;
                        }
                        else {
                            responseItem.isExpired = false;
                        }
                    });

                    if (!showExpired) {
                        tableData = tableData.filter(responseItem => !responseItem.isExpired);
                    }

                    this.setState({
                        isLoadingData: false,
                        selectedValuationMethod: selectedValuationMethod,
                        tableData: CommonService.addOrdinalColumn(tableData),
                        tableTitle: selectedTenant.name + " - " + selectedSite.siteName,
                        paintTable: true
                    }, () => {
                        this.setState({ paintTable: false });
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false,
                        tableTitle: "",
                        tableData: [],
                        paintTable: true
                    }, () => {
                        this.setState({ paintTable: false });
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantOffers/GetOffers", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantOffersRouteComponent", "onGetReportClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantOffersRouteComponent", "onGetReportClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onGetReportClick");
        }
    }

    getVehicleConditionScore(rowData, vehicleCondition) {
        let score = vehicleCondition === "Like New" ? rowData.offer_detail.offer.calculationVariable.value.gradeLikeNewConditionValue
            : vehicleCondition === "Very Good" ? rowData.offer_detail.offer.calculationVariable.value.gradeVeryGoodConditionValue
                : vehicleCondition === "Acceptable" ? rowData.offer_detail.offer.calculationVariable.value.gradeAcceptableConditionValue
                    : rowData.offer_detail.offer.calculationVariable.value.gradeMajorIssuesConditionValue;

        return vehicleCondition + " (" + score + ")";
    }

    onViewOfferDetailCallback(rowData) {
        let selectedMMRTrim, adjustedPricingWholesaleAverage = 0;
        let tenantLocationLink = "";
        if (rowData.offer_detail) {
            selectedMMRTrim = rowData.offer_detail.offer.mmrValuesReponse.items[rowData.offer_detail.offer.mmrValuesReponseItemIndex];
            adjustedPricingWholesaleAverage = selectedMMRTrim.adjustedPricing?.wholesale?.average;

            if (rowData.offer_detail.header.useLocations) {
                let tenantLocation = (rowData.offer_detail.header.location.address1 ? rowData.offer_detail.header.location.address1 + " " : "") +
                    (rowData.offer_detail.header.location.address2 ? rowData.offer_detail.header.location.address2 + " " : "") +
                    (rowData.offer_detail.header.location.city ? rowData.offer_detail.header.location.city + " " : "") +
                    (rowData.offer_detail.header.location.state ? rowData.offer_detail.header.location.state + " " : "") +
                    rowData.offer_detail.header.location.zip;
                tenantLocationLink = "https://www.google.com/maps/place/" + tenantLocation.replaceAll(' ', '+');
            }
        }

        return <Fragment>
            <div className="d-flex flex-row align-items-center flex-wrap">
                <div className="form-row">
                    <button type="button" className="btn btn-link" onClick={(event) => this.onToggleViewDetails(event, rowData)}>Detail
                        {
                            rowData.showViewDetails
                                ? <span className="far fa-sort-up admin-icon" />
                                : <span className="far fa-sort-down admin-icon" />
                        }
                    </button>
                    <a className="btn btn-link admin-offers-salesforce-link" target="_blank" rel="noreferrer" href={rowData.offerUrl ? rowData.offerUrl : "https://" + this.state.siteDomain + "/offer?offernumber=" + rowData.offerNumber}>
                        Offer
                    </a>
                    <button type="button" className="btn btn-link" onClick={(event) => this.onRawViewClick(event, rowData)}>
                        Raw View
                    </button>
                    <a className={"btn btn-link admin-offers-salesforce-link" + (rowData.crmId ? "" : " disabled")} target="_blank" rel="noreferrer" href={"https://delgrandedealergroup.lightning.force.com/lightning/r/Lead/" + rowData.crmId + "/view"}>
                        CRM
                    </a>
                    <button type="button" className="btn btn-link" onClick={(event) => this.onCRMDeliveryClick(event, rowData)}>
                        CRM Delivery
                    </button>
                </div>
            </div>
            {
                rowData.showViewDetails
                    ? rowData.offer_detail
                        ? <table className="admin-offers-detail">
                            <thead>
                                <tr>
                                    <th style={{ "width": "6%" }}></th>
                                    <th style={{ "width": "18%" }}></th>
                                    <th style={{ "width": "6%" }}></th>
                                    <th style={{ "width": "12%" }}></th>
                                    <th style={{ "width": "6%" }}></th>
                                    <th style={{ "width": "12%" }}></th>
                                    <th style={{ "width": "5%" }}></th>
                                    <th style={{ "width": "12%" }}></th>
                                    <th style={{ "width": "9%" }}></th>
                                    <th style={{ "width": "14%" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">Vehicle Details</td>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">AutoCheck Details</td>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">
                                        MMR Additional Information
                                    </td>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">Customer Information</td>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">Offer</td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Offer Number:</td>
                                    <td>
                                        <div className="d-flex flex-row align-items-center flex-wrap">
                                            <span className="admin-offers-detail-show-ellipsis" title={rowData.offer_detail.header.offerNumber}>{rowData.offer_detail.header.offerNumber}</span>
                                            <button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.offer_detail.header.offerNumber)}>
                                                <span className="far fa-copy" />
                                            </button>
                                        </div>
                                    </td>
                                    <td className="app-fw-700">Owner:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleHistory
                                                ? rowData.offer_detail.vehicleHistory.owners
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Historical Last 30 Days Price:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.historicalAverages
                                                && selectedMMRTrim.historicalAverages.last30Days
                                                && selectedMMRTrim.historicalAverages.last30Days.price != null
                                                ? CommonService.formatCurrency_2(selectedMMRTrim.historicalAverages.last30Days.price)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">First:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.customerInfo
                                                ? rowData.offer_detail.customerInfo.first
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Includes Build Options:</td>
                                    <td>{selectedMMRTrim
                                        && selectedMMRTrim.adjustedPricing
                                        && selectedMMRTrim.adjustedPricing.adjustedBy
                                        && selectedMMRTrim.adjustedPricing.adjustedBy.buildOptions === true ? "Yes" : "No"}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Year:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail
                                                ? rowData.offer_detail.vehicleDetail.year
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Accidents:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleHistory
                                                ? rowData.offer_detail.vehicleHistory.accidentCount
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Wholesale Average:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.wholesale
                                                && selectedMMRTrim.wholesale.average !== null
                                                ? CommonService.formatCurrency_2(selectedMMRTrim.wholesale.average)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Last:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.customerInfo
                                                ? rowData.offer_detail.customerInfo.last
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Average Grade:</td>
                                    <td className={rowData.offer_detail.offer.averageGrade < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatNumber_1(rowData.offer_detail.offer.averageGrade)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Make:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail
                                                ? rowData.offer_detail.vehicleDetail.make
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Accident Response:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleHistory
                                                ? rowData.offer_detail.vehicleHistory.accidentResponse
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Next Month Wholesale Forecast:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.forecast
                                                && selectedMMRTrim.forecast.nextMonth
                                                && selectedMMRTrim.forecast.nextMonth.wholesale !== null
                                                ? CommonService.formatCurrency_2(selectedMMRTrim.forecast.nextMonth.wholesale)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Email:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.customerInfo
                                                ? <Fragment>
                                                    {rowData.offer_detail.customerInfo.email}
                                                    < button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.offer_detail.customerInfo.email)}>
                                                        <span className="far fa-copy" />
                                                    </button>
                                                </Fragment>
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Adjusted Wholesale Average:</td>
                                    <td className={adjustedPricingWholesaleAverage < 0 ? "text-danger" : ""}>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.adjustedPricing?.wholesale.average
                                                ? CommonService.formatCurrency_2(adjustedPricingWholesaleAverage)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Model:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail
                                                ? rowData.offer_detail.vehicleDetail.model
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Issue Categories:</td>
                                    <td title={rowData.offer_detail.offer ? (rowData.offer_detail.offer.issueCategories ? rowData.offer_detail.offer.issueCategories.join(", ") : "") : ""}>{rowData.offer_detail.offer ? (rowData.offer_detail.offer.issueCategories ? rowData.offer_detail.offer.issueCategories.join(", ") : "") : ""}</td>
                                    <td className="app-fw-700">Average Grade (across similar vehicles):</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.averageGrade != null
                                                ? CommonService.formatNumber(selectedMMRTrim.averageGrade)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Phone:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.customerInfo
                                                ? CommonService.formatPhoneNumber(rowData.offer_detail.customerInfo.phone)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Odometer Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.odometerAdjustment < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.odometerAdjustment)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">License Plate:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail
                                                ? rowData.offer_detail.vehicleDetail.licensePlate
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Average Odometer (across similar vehicles):</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.averageOdometer !== null
                                                ? CommonService.formatNumber(selectedMMRTrim.averageOdometer)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Zip:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.customerInfo
                                                ? <Fragment>
                                                    {rowData.offer_detail.customerInfo.zip}
                                                    <button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.offer_detail.customerInfo.zip)}>
                                                        <span className="far fa-copy" />
                                                    </button>
                                                </Fragment>
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Forecast Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.forecastAdjustment < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.forecastAdjustment)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">License Plate State:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail
                                                ? rowData.offer_detail.vehicleDetail.licensePlateState
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">
                                        Vehicle Condition
                                    </td>
                                    <td className="app-fw-700">Adjusted Pricing Confidence Indicator:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.adjustedPricing
                                                && selectedMMRTrim.adjustedPricing.confidenceInterval
                                                && selectedMMRTrim.adjustedPricing.confidenceInterval.confidenceIndicator !== null
                                                ? CommonService.formatNumber(selectedMMRTrim.adjustedPricing.confidenceInterval.confidenceIndicator)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700" style={{ "verticalAlign": "top" }}>
                                        {
                                            rowData.offer_detail.header.useLocations
                                                ? "Location:"
                                                : null
                                        }
                                    </td>
                                    {
                                        rowData.offer_detail.header.useLocations
                                            ? <td>
                                                <a href={tenantLocationLink} target="_blank" rel="noopener noreferrer">
                                                    {rowData.offer_detail.header.location.name}
                                                </a>
                                            </td>
                                            : <td></td>
                                    }
                                    <td className="app-fw-700">Tire Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.tireAdjustment < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.tireAdjustment)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Trim:</td>
                                    <td>{rowData.offer_detail.vehicleDetail ? rowData.offer_detail.vehicleDetail.trim : ""}</td>
                                    <td className="app-fw-700">Exterior Condition:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleCondition
                                                ? this.getVehicleConditionScore(rowData, rowData.offer_detail.vehicleCondition.exterior)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Adjusted Pricing High Confidence Interval:</td>
                                    <td>{
                                        selectedMMRTrim
                                            && selectedMMRTrim.adjustedPricing
                                            && selectedMMRTrim.adjustedPricing.confidenceInterval
                                            && selectedMMRTrim.adjustedPricing.confidenceInterval.priceRange
                                            && selectedMMRTrim.adjustedPricing.confidenceInterval.priceRange.adjustedHigh !== null
                                            ? CommonService.formatCurrency_2(selectedMMRTrim.adjustedPricing.confidenceInterval.priceRange.adjustedHigh)
                                            : ""
                                    }
                                    </td>
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Windshield Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.windShieldAdjustment < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.windShieldAdjustment)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Color:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail.colorSimpleTitle
                                                ? rowData.offer_detail.vehicleDetail.colorSimpleTitle
                                                :
                                                ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Interior Condition:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleCondition
                                                ? this.getVehicleConditionScore(rowData, rowData.offer_detail.vehicleCondition.interior)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Adjusted Pricing Low Confidence Interval:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.adjustedPricing
                                                && selectedMMRTrim.adjustedPricing.confidenceInterval
                                                && selectedMMRTrim.adjustedPricing.confidenceInterval.priceRange
                                                && selectedMMRTrim.adjustedPricing.confidenceInterval.priceRange.adjustedLow !== null
                                                ? CommonService.formatCurrency_2(selectedMMRTrim.adjustedPricing.confidenceInterval.priceRange.adjustedLow)
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" className="app-fw-700 admin-offers-detail-header">Calculation Configuration</td>
                                    <td className="app-fw-700">General Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.generalAdjustment < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.generalAdjustment)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="app-fw-700">Odometer:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleDetail
                                                ? <Fragment>
                                                    {CommonService.formatNumber(rowData.offer_detail.vehicleDetail.odometer)}
                                                    <button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.offer_detail.vehicleDetail.odometer)}>
                                                        <span className="far fa-copy" />
                                                    </button>
                                                </Fragment>
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Mechanical Condition:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleCondition
                                                ? this.getVehicleConditionScore(rowData, rowData.offer_detail.vehicleCondition.mechanical)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Adjusted Pricing Region:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.adjustedPricing
                                                && selectedMMRTrim.adjustedPricing.adjustedBy
                                                ? selectedMMRTrim.adjustedPricing.adjustedBy.Region
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Calculation Rule:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.offer.calculationVariable.key.make
                                                ? rowData.offer_detail.offer.calculationVariable.key.make + " "
                                                : "(any Make) "}{rowData.offer_detail.offer.calculationVariable.key.year
                                                    ? rowData.offer_detail.offer.calculationVariable.key.year + " "
                                                    : "(any Year) "}{rowData.offer_detail.offer.calculationVariable.key.model
                                                        ? rowData.offer_detail.offer.calculationVariable.key.model + " "
                                                        : "(any Model) "
                                        }
                                    </td>
                                    <td className="app-fw-700">Accident Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.accidentDeduction < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.accidentDeduction)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Tire Condition (&gt;50% tread on all):</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleCondition
                                                ? rowData.offer_detail.vehicleCondition.tire
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Sample Size:</td>
                                    <td>
                                        {
                                            selectedMMRTrim
                                                && selectedMMRTrim.sampleSize !== null
                                                ? CommonService.formatNumber(selectedMMRTrim.sampleSize)
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Tire Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.calculationVariable.value.tireAdjustmentBelowThresholdAmount || rowData.offer_detail.offer.calculationVariable.value.tireAdjustmentAboveThresholdAmount < 0 ? "text-danger" : ""}>
                                        {
                                            adjustedPricingWholesaleAverage > rowData.offer_detail.offer.calculationVariable.value.tireAdjustmentThreshold
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.tireAdjustmentAboveThresholdAmount)
                                                : CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.tireAdjustmentBelowThresholdAmount)
                                        }
                                    </td>
                                    <td className="app-fw-700">Wholesale Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.wholesaleAdjustment < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.wholesaleAdjustment)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Windshield Condition (No cracks, chips):</td>
                                    <td>
                                        {
                                            rowData.offer_detail.vehicleCondition
                                                ? rowData.offer_detail.vehicleCondition.windshield
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Trim Count:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.offer?.mmrValuesReponse?.items
                                                ? rowData.offer_detail.offer.mmrValuesReponse.items.length
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Windshield Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.calculationVariable.value.windshieldAdjustmentBelowThresholdAmount || rowData.offer_detail.offer.calculationVariable.value.windshieldAdjustmentAboveThresholdAmount < 0 ? "text-danger" : ""}>
                                        {
                                            adjustedPricingWholesaleAverage > rowData.offer_detail.offer.calculationVariable.value.windshieldAdjustmentThreshold
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.windshieldAdjustmentAboveThresholdAmount)
                                                : CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.windshieldAdjustmentBelowThresholdAmount)
                                        }
                                    </td>
                                    <td className="app-fw-700">Offer (Rounded):</td>
                                    <td className={rowData.offer_detail.offer.offer < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? CommonService.formatCurrency_2(rowData.offer_detail.offer.offer)
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td className="app-fw-700">General Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.calculationVariable.value.generalAdjustmentIsDollar && rowData.offer_detail.offer.calculationVariable.value.generalAdjustmentValue < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.calculationVariable.value.generalAdjustmentIsDollar
                                                    ? CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.generalAdjustmentValue)
                                                    : CommonService.formatNumber_1(rowData.offer_detail.offer.calculationVariable.value.generalAdjustmentValue * 100) + "%"
                                                : ""
                                        }
                                    </td>
                                    <td className="app-fw-700">Error Message:</td>
                                    <td title={rowData.offer_detail.offer ? rowData.offer_detail.offer.errorMessage : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.errorMessage
                                                : ""
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Accident Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.calculationVariable.value.accidentAdjustmentIsDollar && rowData.offer_detail.offer.calculationVariable.value.accidentAdjustmentValue < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.calculationVariable.value.accidentAdjustmentIsDollar
                                                    ? CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.accidentAdjustmentValue)
                                                    : CommonService.formatNumber_1(rowData.offer_detail.offer.calculationVariable.value.accidentAdjustmentValue * 100) + "%"
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" />
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Wholesale Adjustment:</td>
                                    <td className={rowData.offer_detail.offer.calculationVariable.value.wholesaleAdjustmentIsDollar && rowData.offer_detail.offer.calculationVariable.value.wholesaleAdjustmentValue < 0 ? "text-danger" : ""}>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.calculationVariable.value.wholesaleAdjustmentIsDollar
                                                    ? CommonService.formatCurrency_2(rowData.offer_detail.offer.calculationVariable.value.wholesaleAdjustmentValue)
                                                    : CommonService.formatNumber_1(rowData.offer_detail.offer.calculationVariable.value.wholesaleAdjustmentValue * 100) + "%"
                                                : ""}
                                    </td>
                                    <td colSpan="2" />
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Odometer Adjustment:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.calculationVariable.value.odometerAdjustmentEnabled === true
                                                    ? "Yes"
                                                    : "No"
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" />
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Forecast Adjustment:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.calculationVariable.value.forecastAdjustmentEnabled === true
                                                    ? "Yes"
                                                    : "No"
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" />
                                </tr>
                                <tr>
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td colSpan="2" />
                                    <td className="app-fw-700">Enable Offer:</td>
                                    <td>
                                        {
                                            rowData.offer_detail.offer
                                                ? rowData.offer_detail.offer.calculationVariable.value.enableOfferCalculation === true
                                                    ? "Yes"
                                                    : "No"
                                                : ""
                                        }
                                    </td>
                                    <td colSpan="2" />
                                </tr>
                            </tbody>
                        </table>
                        : <SellToWebSpinnerComponent showSpinner={!rowData.offer_detail} />
                    : null
            }
        </Fragment>;
    }

    onToggleViewDetails(event, rowData) {
        rowData.showViewDetails = rowData.showViewDetails ? false : true;
        this.setState({
            paintTable: true
        }, () => {
            this.setState({ paintTable: false });
        });

        try {
            if (!rowData.offer_detail) {
                let inputData = {
                    offerNumber: rowData.offerNumber
                };
                this.props.applicationInsights.trackTrace({ message: "TenantOffersRouteComponent/onToggleViewDetails", properties: { ...inputData, logon: this.props.logon } });
                fetch("/Offer/ReadOffer", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8;"
                    },
                    body: JSON.stringify(inputData),
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                    .then(parsedResponse => {
                        rowData.offer_detail = parsedResponse;
                        this.setState({
                            paintTable: true
                        }, () => {
                            this.setState({ paintTable: false });
                        });
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Offer/ReadOffer", ...inputData, ...parsedError, logon: this.props.logon } });
                                    console.logError(parsedError, "TenantOffersRouteComponent", "onToggleViewDetails");
                                    this.props.onShowAlert("danger", parsedError);
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "TenantOffersRouteComponent", "onToggleViewDetails");
                                });
                        }
                    });
            }
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onToggleViewDetails");
        }
    }

    onRawViewClick(event, rowData) {
        try {
            this.setState({
                rawViewTitle: "Offer: " + rowData.offerNumber,
                showRawViewPopup: true
            });

            if (!rowData.offer_detail) {
                let inputData = {
                    offerNumber: rowData.offerNumber
                };
                this.props.applicationInsights.trackTrace({ message: "TenantOffersRouteComponent/onRawViewClick", properties: { ...inputData, logon: this.props.logon } });
                fetch("/Offer/ReadOffer", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8;"
                    },
                    body: JSON.stringify(inputData),
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                    .then(parsedResponse => {
                        rowData.offer_detail = parsedResponse;
                        this.setState({
                            rawViewData: JSON.stringify(parsedResponse, null, "\t")
                        });
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Offer/ReadOffer", ...inputData, ...parsedError, logon: this.props.logon } });
                                    console.logError(parsedError, "TenantOffersRouteComponent", "onRawViewClick");
                                    this.props.onShowAlert("danger", parsedError);
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "TenantOffersRouteComponent", "onRawViewClick");
                                });
                        }
                    });
            }
            else {
                this.setState({
                    rawViewData: JSON.stringify(rowData.offer_detail, null, "\t")
                });
            }
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onRawViewClick");
        }
    }

    formatXml(node, level = 0) {
        let indent = "&nbsp;&nbsp;".repeat(level);
        let output = "";

        if (node.nodeType === 1) {
            output += indent + "&lt;" + node.nodeName;

            Array.from(node.attributes).forEach(function (attr) {
                output += " " + attr.name + '="' + attr.value + '"';
            });

            if (node.childNodes.length === 0) {
                output += "/&gt;<br/>";
            } else {
                output += "&gt;<br/>";

                Array.from(node.childNodes).forEach(function (child) {
                    output += this.formatXml(child, level + 1);
                }.bind(this));

                output += indent + "&lt;/" + node.nodeName + "&gt;<br/>";
            }
        }
        else if (node.nodeType === 3) {
            var text = node.nodeValue.trim();
            if (text) {
                output += indent + '<span class="admin-offers-crm-xml-value">' + text + '</span><br/>';
            }
        }
        else if (node.nodeType === 4) {
            let cdata = node.nodeValue.trim();
            cdata = cdata.replace(/([A-Za-z0-9_.]+:)/g, "<br/>" + indent + "$1");
            output += indent + "&lt;![CDATA[";
            output += indent + '<span class="admin-offers-crm-xml-value">' + cdata + '</span><br/>';
            output += indent + "]]&gt;<br/>";
        }

        return output;
    }

    onCRMDeliveryClick(event, rowData) {
        try {
            this.setState({
                rawViewCRMTitle: "CRM Delivery: " + rowData.offerNumber,
                showCRMRawViewPopup: true,
                offerNumber: rowData.offerNumber
            });

            if (!rowData.crm_content && !rowData.crm_xml_content) {
                let inputData = {
                    offerNumber: rowData.offerNumber
                };
                this.props.applicationInsights.trackTrace({ message: "TenantOffersRouteComponent/onCRMDeliveryClick", properties: { ...inputData, logon: this.props.logon } });
                fetch("/TenantOffers/GetCRMDeliveryRawView", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8;"
                    },
                    body: JSON.stringify(inputData),
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                    .then(parsedResponse => {
                        rowData.crm_rawViewData = JSON.stringify(parsedResponse, null, "\t");
                        rowData.crm_content = parsedResponse;
                        if (parsedResponse.CRMDeliveryFormat === "JSON") {
                            rowData.crm_xml_content = parsedResponse.CRMDeliveryContent;
                        }
                        else {
                            let parsedXMLResponse = $.parseXML(parsedResponse.CRMDeliveryContent);
                            rowData.crm_xml_content = this.formatXml(parsedXMLResponse.documentElement);
                        }

                        this.setState({
                            rawViewCRMData: rowData.crm_rawViewData,
                            crmContent: rowData.crm_content,
                            crmXmlContent: rowData.crm_xml_content
                        });
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.setState({
                                        crmContent: "No CRM Delivery content available",
                                        crmXmlContent: "No CRM Delivery content available"
                                    });
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "TenantOffers/GetCRMDeliveryRawView", ...inputData, ...parsedError, logon: this.props.logon } });
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "TenantOffersRouteComponent", "onCRMDeliveryClick");
                                });
                        }
                    });
            }
            else {
                this.setState({
                    rawViewCRMData: rowData.crm_rawViewData,
                    crmContent: rowData.crm_content,
                    crmXmlContent: rowData.crm_xml_content
                });
            }
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCRMDeliveryClick");
        }
    }

    onConfirmedCRMDeliveryClick(event) {
        try {
            this.setState({
                rawViewCRMTitle: "CRM Delivery: " + this.state.offerNumber,
                showCRMRawViewPopup: true
            });

            let inputData = {
                offerNumber: this.state.offerNumber
            };
            this.props.applicationInsights.trackTrace({ message: "TenantOffersRouteComponent/onConfirmedCRMDeliveryClick", properties: { ...inputData, logon: this.props.logon } });
            fetch("/TenantOffers/GetConfirmedCRMDeliveryRawView", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    let crm_content, crm_xml_content = "";
                    crm_content = parsedResponse;
                    if (parsedResponse.CRMDeliveryFormat === "JSON") {
                        crm_xml_content = parsedResponse.CRMDeliveryContent;
                    }
                    else {
                        let parsedXMLResponse = $.parseXML(parsedResponse.CRMDeliveryContent);
                        crm_xml_content = this.formatXml(parsedXMLResponse.documentElement);
                    }

                    this.setState({
                        crmContentConfirmed: crm_content,
                        crmXmlContentConfirmed: crm_xml_content
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.setState({
                                    crmContentConfirmed: "No CRM Delivery content available",
                                    crmXmlContentConfirmed: "No CRM Delivery content available"
                                });
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantOffers/GetConfirmedCRMDeliveryRawView", ...inputData, ...parsedError, logon: this.props.logon } });
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantOffersRouteComponent", "onConfirmedCRMDeliveryClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onConfirmedCRMDeliveryClick");
        }
    }

    onCancelRawView(event) {
        try {
            this.setState({
                showRawViewPopup: false,
                rawViewTitle: "",
                rawViewData: ""
            });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCancelClick");
        }
    }

    onCancelCRMRawView(event) {
        try {
            this.setState({
                showCRMRawViewPopup: false,
                rawViewCRMTitle: "",
                rawViewCRMData: "",
                crmContent: "",
                crmXmlContent: "",
                crmContentConfirmed: "",
                crmXmlContentConfirmed: ""
            });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCancelCRMRawView");
        }
    }

    onCopyTableCallBack(event) {
        try {
            this.props.onShowAlert("success", { message: "Copied to Clipboard." }, 4000);
            CommonService.clientAzureStorageLog("TenantOffersRouteComponent", "onCopyTableCallBack", null, null, null, null, this.props.applicationInsights);
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCopyTableCallBack");
        }
    }

    onCopyRawView(event) {
        try {
            navigator.clipboard.writeText(this.state.rawViewData)
                .then(() => {
                    this.props.onShowAlert("success", { message: "Copied to Clipboard." }, 4000);
                    CommonService.clientAzureStorageLog("TenantOffersRouteComponent", "onCopyRawView", null, null, null, null, this.props.applicationInsights);
                });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCopyRawView");
        }
    }

    onCopyCRMRawView(event) {
        try {
            navigator.clipboard.writeText(this.state.rawViewCRMData)
                .then(() => {
                    this.props.onShowAlert("success", { message: "Copied to Clipboard." }, 4000);
                    CommonService.clientAzureStorageLog("TenantOffersRouteComponent", "onCopyCRMRawView", null, null, null, null, this.props.applicationInsights);
                });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCopyCRMRawView");
        }
    }

    onCopyColumnClick(event, columnValue) {
        try {
            navigator.clipboard.writeText(columnValue)
                .then(() => {
                    this.props.onShowAlert("success", { message: "Copied to Clipboard." }, 4000);
                    CommonService.clientAzureStorageLog("TenantOffersRouteComponent", "onCopyColumnClick", null, null, null, null, this.props.applicationInsights);
                });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCopyColumnClick");
        }
    }

    onOfferNumberColumnCallback(rowData) {
        return <div className="d-flex flex-row align-items-center flex-wrap admin-offers-number-column">
            <span className="admin-offers-detail-show-ellipsis" style={{ "marginRight": "-7px" }} title={rowData.offerNumber}>{rowData.offerNumber}</span>
            <button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.offerNumber)}>
                <span className="far fa-copy" />
            </button>
        </div>;
    }

    onVinColumnCallback(rowData) {
        return <div className="d-flex flex-row align-items-center flex-wrap admin-offer-vin-column" >
            {rowData.vehicle}&nbsp;
            <span title={rowData.vin}>({rowData.vin})</span>
            <button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.vin)}>
                <span className="far fa-copy" />
            </button>
        </div>;
    }

    onCustomerEmailColumnCallback(rowData) {
        return <div className="d-flex flex-row align-items-center flex-wrap admin-offers-email-column">
            {rowData.customerName}&nbsp;
            <span title={rowData.email}>({rowData.email})</span>
            <button type="button" className="btn btn-link admin-offers-copy-btn" onClick={(event) => this.onCopyColumnClick(event, rowData.email)}>
                <span className="far fa-copy" />
            </button>
        </div>;
    }

    render() {
        let legendText = <div className="text-nowrap d-inline">
            <div className="d-inline admin-legend admin-offers-confirm" />&nbsp;&nbsp;&nbsp;Confirmed
            <div className="d-inline admin-legend admin-offers-warn" />&nbsp;&nbsp;&nbsp;Warn
            <div className="d-inline admin-legend admin-offers-error" />&nbsp;&nbsp;&nbsp;Error
            <div className="d-inline admin-legend admin-offers-expired" />&nbsp;&nbsp;&nbsp;Expired
            <div className="d-inline admin-legend admin-offers-source" />&nbsp;&nbsp;&nbsp;Internal
        </div>;

        return <SellToWebAdminPageComponent>
            <div className="admin-flex-item admin-body">
                <TenantOffersRawViewComponent
                    rawViewTitle={this.state.rawViewTitle}
                    showRawViewPopup={this.state.showRawViewPopup}
                    onCancelRawView={this.onCancelRawView}
                    onCopyRawView={this.onCopyRawView}
                    rawViewData={this.state.rawViewData}
                />
                <TenantOffersCRMDeliveryRawViewComponent
                    rawViewCRMTitle={this.state.rawViewCRMTitle}
                    showCRMRawViewPopup={this.state.showCRMRawViewPopup}
                    onCancelCRMRawView={this.onCancelCRMRawView}
                    onCopyCRMRawView={this.onCopyCRMRawView}
                    crmContent={this.state.crmContent}
                    crmXmlContent={this.state.crmXmlContent}
                    crmContentConfirmed={this.state.crmContentConfirmed}
                    crmXmlContentConfirmed={this.state.crmXmlContentConfirmed}
                    onConfirmedCRMDeliveryClick={this.onConfirmedCRMDeliveryClick}
                />
                <div className="d-flex flex-column admin-fill-content">
                    <TenantOffersQueryComponent
                        tenants={this.state.tenants}
                        isLoadingData={this.state.isLoadingData}
                        onGetReportClick={this.onGetReportClick}
                        onShowAlert={this.props.onShowAlert}
                        isGlobalAdmin={this.props.isGlobalAdmin}
                        applicationInsights={this.props.applicationInsights}
                        logon={this.state.logon}
                    />
                    <br />
                    <SellToWebTableComponent cardClassName="admin-flex-item" headerText={this.state.tableTitle} tableData={this.state.tableData} paintTable={this.state.paintTable} legendText={legendText} tablePageSize={CommonService.tablePageSize}
                        copyTableConfig={{ "columns": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], onCopyTableCallBack: this.onCopyTableCallBack }}
                    >
                        <SellToWebTableRowComponent>
                            <SellToWebTableColumnComponent headerText="#" dataColumn={CommonService.ordinalColumnName} dataType="number" sortColumn={CommonService.ordinalColumnName} />
                            <SellToWebTableColumnComponent headerText="Source" dataColumn="source" sortColumn="source" filterColumn="source" />
                            <SellToWebTableColumnComponent headerText="Offer Number" dataColumnCallback={this.onOfferNumberColumnCallback} headerClassName="admin-offers-number-column" dataColumn="offerNumber" sortColumn="offerNumber" filterColumn="offerNumber" />
                            <SellToWebTableColumnComponent headerText="Offer Date" dataColumn="offerDate" sortColumn="offerDate" filterColumn="offerDate" dataType="dateTime" />
                            <SellToWebTableColumnComponent headerText="Vehicle (VIN)" dataColumn="vehicleVIN" sortColumn="vehicleVIN" filterColumn="vehicleVIN" dataColumnCallback={this.onVinColumnCallback} headerClassName="admin-offer-vin-column" />
                            <SellToWebTableColumnComponent headerText="Customer (Email)" dataColumn="customerEmail" sortColumn="customerEmail" filterColumn="customerEmail" dataColumnCallback={this.onCustomerEmailColumnCallback} />
                            <SellToWebTableColumnComponent headerText="Location" dataColumn="locationName" sortColumn="locationName" filterColumn="locationName" />
                            <SellToWebTableColumnComponent headerText="Offer" dataColumn="offerAmount" sortColumn="offerAmount" filterColumn="offerAmount" dataType="money_2" />
                            <SellToWebTableColumnComponent headerText="Effective Date" dataColumn="effectiveDate" sortColumn="effectiveDate" filterColumn="effectiveDate" dataType="date" />
                            <SellToWebTableColumnComponent headerText="Expiration Date" dataColumn="expirationDate" sortColumn="expirationDate" filterColumn="expirationDate" dataType="date" />
                            <SellToWebTableColumnComponent headerText="Status" dataColumn="status" sortColumn="status" filterColumn="status" />
                        </SellToWebTableRowComponent>
                        <SellToWebTableRowComponent>
                            <SellToWebTableColumnComponent colSpan="11" dataColumnCallback={this.onViewOfferDetailCallback} />
                        </SellToWebTableRowComponent>
                    </SellToWebTableComponent>
                </div>
            </div>
        </SellToWebAdminPageComponent>;
    }
}